import { QuestionIds } from '../constants/QuestionIds';
import { Steps } from '../constants/StepsLabels';
import { DefaultOnboardingSteps } from './DefaultOnboardingSteps';
import { GadTestSteps } from './GadSteps';
import { BasicSteps } from './BasicSteps';
import { EducationV1TestSteps } from './EducationQuizV1Steps';
import { EducationV2TestSteps } from './EducationQuizV2Steps';
import { EducationV3TestSteps } from './EducationQuizV3Steps';
import { InsomniaQuizV1Steps } from './InsomniaQuizV1Steps';
import { InsomniaQuizV2Steps } from './InsomniaQuizV2Steps';
import { AdhdSteps } from './AdhdFlowSteps';
import { LivenSteps } from './LivenSteps';
import { CreoQuizSteps } from './CreoQuizSteps';

interface QuizFlags {
  isAdhdTest: boolean;
  isDefaultOnboarding: boolean;
  isEducationV1Quiz: boolean;
  isEducationV2Quiz: boolean;
  isEducationV3Quiz: boolean;
  isGadTest: boolean;
  isInsomniaV1Quiz: boolean;
  isInsomniaV2Quiz: boolean;
  isLivenOnboardingFlow: boolean;
  isCreoQuiz: boolean;
}

export const getSteps = ({
  isAdhdTest,
  isDefaultOnboarding,
  isEducationV1Quiz,
  isEducationV2Quiz,
  isEducationV3Quiz,
  isGadTest,
  isInsomniaV1Quiz,
  isInsomniaV2Quiz,
  isLivenOnboardingFlow,
  isCreoQuiz,
}: QuizFlags): Map<Steps, QuestionIds[]> => {
  switch (true) {
    case isDefaultOnboarding:
      return DefaultOnboardingSteps;
    case isGadTest:
      return GadTestSteps;
    case isEducationV1Quiz:
      return EducationV1TestSteps;
    case isEducationV2Quiz:
      return EducationV2TestSteps;
    case isEducationV3Quiz:
      return EducationV3TestSteps;
    case isInsomniaV1Quiz:
      return InsomniaQuizV1Steps;
    case isInsomniaV2Quiz:
      return InsomniaQuizV2Steps;
    case isAdhdTest:
      return AdhdSteps;
    case isLivenOnboardingFlow:
      return LivenSteps;
    case isCreoQuiz:
      return CreoQuizSteps;
    default:
      return BasicSteps;
  }
};
